(() => {
  const menuButton = document.querySelector('.menu-toggle');
  const menu = document.querySelector('.primary-nav');
  if (menuButton && menu) {
    menuButton.addEventListener('click', () => {
      const open = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!open));
      menu.classList.toggle('is-open', !open);
    });
  }

  document.querySelectorAll('[data-sort-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.assign(url.toString());
    });
  });

  const initializeMosaic = (grid) => {
    const cards = [...grid.querySelectorAll('.product-card--mosaic')];
    if (!cards.length) return;

    let resizeFrame;
    const resizeCards = () => {
      const styles = window.getComputedStyle(grid);
      const rowHeight = Number.parseFloat(styles.gridAutoRows) || 8;
      const rowGap = Number.parseFloat(styles.rowGap) || 0;

      cards.forEach((card) => {
        card.style.gridRowEnd = 'auto';
        const cardHeight = card.getBoundingClientRect().height;
        const rowSpan = Math.max(1, Math.ceil((cardHeight + rowGap) / (rowHeight + rowGap)));
        card.style.gridRowEnd = `span ${rowSpan}`;
      });
    };

    const queueResize = () => {
      window.cancelAnimationFrame(resizeFrame);
      resizeFrame = window.requestAnimationFrame(resizeCards);
    };

    cards.forEach((card) => {
      const image = card.querySelector('img');
      if (image && !image.complete) image.addEventListener('load', queueResize, { once: true });
    });

    queueResize();
    window.addEventListener('resize', queueResize, { passive: true });
  };

  document.querySelectorAll('[data-mosaic-grid]').forEach(initializeMosaic);

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const json = root.querySelector('[data-product-variants]');
    const form = root.querySelector('[data-product-form]');
    if (!json || !form) return;

    let variants;
    try {
      variants = JSON.parse(json.textContent);
    } catch {
      return;
    }

    const optionGroups = [...form.querySelectorAll('[data-option-position]')];
    const variantId = form.querySelector('[data-variant-id]');
    const addButton = form.querySelector('[data-add-button]');
    const addLabel = form.querySelector('[data-add-label]');
    const availability = form.querySelector('[data-availability]');
    const price = root.querySelector('[data-price]');
    const variantDetailValues = [...root.querySelectorAll('[data-variant-detail-index]')];
    const variantSku = root.querySelector('[data-variant-sku]');
    const variantSkuRow = root.querySelector('[data-variant-sku-row]');
    const currency = root.dataset.currency || 'USD';
    const findOptionGroup = (name) => optionGroups.find((group) => {
      const inputName = group.querySelector('input')?.name.toLowerCase();
      return group.dataset.optionName === name || inputName === `options[${name}]`;
    });
    const typeGroup = findOptionGroup('type');
    const mediaGroup = findOptionGroup('media');
    const sizeGroup = findOptionGroup('size');
    if (typeGroup) typeGroup.dataset.optionName = 'type';
    if (mediaGroup) mediaGroup.dataset.optionName = 'media';
    if (sizeGroup) sizeGroup.dataset.optionName = 'size';

    const optionCount = variants.reduce((count, variant) => Math.max(count, variant.options.length), 0);
    const optionIndex = (group) => Number(group?.dataset.optionPosition) - 1;
    const selectedOptions = () => {
      const selected = Array(optionCount).fill('');
      optionGroups.forEach((group) => {
        const groupIndex = optionIndex(group);
        const checked = group.querySelector('input:checked');
        if (groupIndex >= 0) selected[groupIndex] = checked ? checked.value : '';
      });
      return selected;
    };

    const selectFirstMatchingOption = (group, matchesUpstream) => {
      if (!group) return;

      const groupIndex = optionIndex(group);
      const inputs = [...group.querySelectorAll('input')];
      const optionExists = (input, availableOnly) => variants.some((candidate) =>
        (!availableOnly || candidate.available) &&
        candidate.options[groupIndex] === input.value &&
        matchesUpstream(candidate)
      );
      const nextInput = inputs.find((input) => optionExists(input, true))
        || inputs.find((input) => optionExists(input, false));

      if (nextInput) {
        inputs.forEach((input) => {
          input.checked = input === nextInput;
        });
      }
    };

    const selectFirstSize = () => {
      if (!sizeGroup) return;

      const selected = selectedOptions();
      const typeIndex = optionIndex(typeGroup);
      const mediaIndex = optionIndex(mediaGroup);
      selectFirstMatchingOption(sizeGroup, (candidate) =>
        (!typeGroup || candidate.options[typeIndex] === selected[typeIndex]) &&
        (!mediaGroup || candidate.options[mediaIndex] === selected[mediaIndex])
      );
    };

    const selectFirstMediaAndSize = () => {
      if (mediaGroup) {
        const selected = selectedOptions();
        const typeIndex = optionIndex(typeGroup);
        selectFirstMatchingOption(mediaGroup, (candidate) =>
          !typeGroup || candidate.options[typeIndex] === selected[typeIndex]
        );
      }

      selectFirstSize();
    };

    const formatMoney = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency
    }).format(cents / 100);

    const updateVariant = () => {
      const selected = selectedOptions();
      optionGroups.forEach((group) => {
        const output = group.querySelector('[data-selected-option]');
        const checked = group.querySelector('input:checked');
        if (output && checked) output.textContent = checked.value;
      });

      const variant = variants.find((candidate) =>
        candidate.options.every((value, index) => value === selected[index])
      );
      const available = Boolean(variant && variant.available);

      if (variantId) variantId.value = variant ? variant.id : '';
      if (addButton) addButton.disabled = !available;
      if (addLabel) addLabel.textContent = available ? 'Add to cart' : (variant ? 'Sold out' : 'Unavailable');
      if (availability) availability.textContent = available ? 'Made to order' : 'Currently unavailable';
      if (price && variant) price.textContent = formatMoney(variant.price);
      variantDetailValues.forEach((output) => {
        const index = Number(output.dataset.variantDetailIndex);
        if (selected[index]) output.textContent = selected[index];
      });
      if (variantSku) variantSku.textContent = variant?.sku || '';
      if (variantSkuRow) variantSkuRow.hidden = !variant?.sku;

      optionGroups.forEach((group) => {
        const groupIndex = optionIndex(group);
        group.querySelectorAll('input').forEach((input) => {
          const possible = variants.some((candidate) => {
            if (!candidate.available || candidate.options[groupIndex] !== input.value) return false;
            if (group === typeGroup) return true;

            const typeIndex = optionIndex(typeGroup);
            if (typeGroup && candidate.options[typeIndex] !== selected[typeIndex]) return false;
            if (group === mediaGroup) return true;

            const mediaIndex = optionIndex(mediaGroup);
            if (mediaGroup && candidate.options[mediaIndex] !== selected[mediaIndex]) return false;
            if (group === sizeGroup) return true;

            return candidate.options.every((value, index) =>
              index === groupIndex ? value === input.value : value === selected[index]
            );
          });
          input.disabled = !possible;
          input.nextElementSibling?.toggleAttribute('data-unavailable', !possible);
        });
      });
    };

    form.addEventListener('change', (event) => {
      const changedGroup = event.target.closest('[data-option-position]');
      if (changedGroup === typeGroup) {
        selectFirstMediaAndSize();
      } else if (changedGroup === mediaGroup) {
        selectFirstSize();
      }
      updateVariant();
    });
    updateVariant();
  });
})();
